module.exports = "/_next/static/images/projectTechnologyDeployment2-dfe256dd101440538cd8d40bfbe48df2.webp";